import React from 'react';
import { Alert } from '@ecargo/web-components';
import { WarningFilled } from '@hangar/react-icons/core/interaction/WarningFilled';
import { useTranslation } from '../../hooks/i18n';
import type { AutomationFeedback } from '../../services/api/flightChanges/types';
import * as S from '../header/styles/DetailHeader.style';

const REJECTED_BY_REASON_CODE = 'REJECTED_BY_REASON_CODE';

export const shouldShowManualReviewBanner = (
  automationFeedback?: AutomationFeedback | null
): boolean => automationFeedback?.automationStatus === REJECTED_BY_REASON_CODE;

export interface ManualReviewBannerProps {
  automationFeedback?: AutomationFeedback | null;
}

/** Uses eCargo `Alert` for manual review feedback — policy: ECADCA-530 §2. */
export const ManualReviewBanner: React.FC<ManualReviewBannerProps> = ({ automationFeedback }) => {
  const { t } = useTranslation();

  if (!shouldShowManualReviewBanner(automationFeedback)) {
    return null;
  }

  return (
    <S.AlertWrapper>
      <Alert
        variant="warning"
        title={t('flightChangeDetails.manualReview.title')}
        description={t('flightChangeDetails.manualReview.description')}
        icon={<WarningFilled size={24} />}
        width="100%"
      />
    </S.AlertWrapper>
  );
};
